import { createAdminFetch, type Route } from './admin-fetch';
import { ADMIN_API, seg } from './respond';
import { authRoutes } from './handlers/auth';
import { catalogRoutes } from './handlers/catalog';
import { currencyRoutes } from './handlers/currencies';
import { engagementRoutes } from './handlers/engagement';
import { peopleRoutes } from './handlers/people';
import { searchRoutes } from './handlers/search';
import { teamRoutes } from './handlers/team';

// Every `/api/*` address the screens use, answered in the browser.
const routes: Route[] = [
  ...authRoutes,
  ...catalogRoutes,
  ...currencyRoutes,
  ...engagementRoutes,
  ...peopleRoutes,
  ...searchRoutes,
  ...teamRoutes,
];

/** The React admin's `adminFetch` — see src/lib/admin-fetch.ts. */
export const adminFetch = createAdminFetch(routes);

/**
 * For a link the browser opens itself (a download): the server address
 * behind one of the screens' `/api/*` addresses. The session cookie
 * travels with it like any other same-site request.
 */
export function adminFileUrl(path: string): string {
  const exportMatch = /^\/api\/surveys\/([^/]+)\/export$/.exec(path);
  if (exportMatch) return `${ADMIN_API}/surveys/${seg(decodeURIComponent(exportMatch[1]))}/export`;
  throw new Error(`No file address for ${path}`);
}
